import { ApiShopperLandingPage } from '@storefronts/common-types'
import Head from 'next/head'
import Script from 'next/script'
import { VariantWithImage } from '../../types'
import { runWhenReady } from './pixelRuntime'

// Ready signal comes from inside the inline snippet (via __sfMarkVendorReady,
// installed by pixelRuntime), not from <Script onReady>. Next.js fires onReady
// before an inline body executes, which would drain the queue while
// window.TriplePixel is still undefined.
export const TripleWhalePixel: React.FC<{
    landingPage: ApiShopperLandingPage
}> = ({ landingPage }) => {
    if (!landingPage.integrations.tripleWhalePixelId) return null
    return (
        <>
            <Head>
                <link
                    rel="preconnect dns-prefetch"
                    href="https://api.config-security.com/"
                    crossOrigin=""
                />
                <link
                    rel="preconnect dns-prefetch"
                    href="https://conf.config-security.com/"
                    crossOrigin=""
                />
                <link
                    rel="preconnect dns-prefetch"
                    href="https://whale.camera/"
                    crossOrigin=""
                />
            </Head>
            <Script id="triple-whale" strategy="afterInteractive">
                {`
                    window.TriplePixelData={TripleName:"${landingPage.integrations.tripleWhalePixelId}",ver:"2.12",plat:"SHOPIFY",isHeadless:true},function(W,H,A,L,E,_,B,N){function O(U,T,P,H,R){void 0===R&&(R=!1),H=new XMLHttpRequest,P?(H.open("POST",U,!0),H.setRequestHeader("Content-Type","text/plain")):H.open("GET",U,!0),H.send(JSON.stringify(P||{})),H.onreadystatechange=function(){4===H.readyState&&200===H.status?(R=H.responseText,U.includes(".txt")?eval(R):P||(N[B]=R)):(299<H.status||H.status<200)&&T&&!R&&(R=!0,O(U,T-1,P))}}if(N=window,!N[H+"sn"]){N[H+"sn"]=1,L=function(){return Date.now().toString(36)+"_"+Math.random().toString(36)};try{A.setItem(H,1+(0|A.getItem(H)||0)),(E=JSON.parse(A.getItem(H+"U")||"[]")).push({u:location.href,r:document.referrer,t:Date.now(),id:L()}),A.setItem(H+"U",JSON.stringify(E))}catch(e){}var i,m,p;A.getItem('"!nC\`')||(_=A,A=N,A[H]||(E=A[H]=function(t,e,a){return void 0===a&&(a=[]),"State"==t?E.s:(W=L(),(E._q=E._q||[]).push([W,t,e].concat(a)),W)},E.s="Installed",E._q=[],E.ch=W,B="configSecurityConfModel",N[B]=1,O("https://conf.config-security.com/model",5),i=L(),m=A[atob("c2NyZWVu")],_.setItem("di_pmt_wt",i),p={id:i,action:"profile",avatar:_.getItem("auth-security_rand_salt_"),time:m[atob("d2lkdGg=")]+":"+m[atob("aGVpZ2h0")],host:A.TriplePixelData.TripleName,plat:A.TriplePixelData.plat,url:window.location.href,ref:document.referrer,ver:A.TriplePixelData.ver},O("https://api.config-security.com/event",5,p),O("https://whale.camera/live/dot.txt",5)))}}("","TriplePixel",localStorage);
                    window.__sfMarkVendorReady && window.__sfMarkVendorReady('tripleWhale');
                    `}
            </Script>
        </>
    )
}

export class TripleWhaleTracker {
    static checkTripleWhale(): boolean {
        return window.hasOwnProperty('TriplePixel')
    }

    static trackAddToCart(variant: VariantWithImage, cartId: string) {
        runWhenReady('tripleWhale', () => {
            if (!TripleWhaleTracker.checkTripleWhale()) return

            window.TriplePixel('AddToCart', {
                item: variant.shopifyId,
                q: 1,
                token: cartId,
            })
        })
    }
}
